<div class="mr-t--md mr-b--md">
    <a class="btn btn-link btn-icon btn-icon--left btn-back"
       *ngIf="!isHome"
       [routerLink]="['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb class="hidden"
            [firstNode]="{label: 'Coupons list', 'url': '/home'}">
    </app-breadcrumb>

    <div class="box">
        <div class="card card--b2c--box pb-1">
            <div class="card--b2c--box__header">
                <div class="card--b2c--box__header--info">
                    <div *ngIf="!isClinicView" class="card--b2c--box__header__title">
                        {{ 'Coupons' | translate }}
                    </div>
                </div>
                <div class="card--b2c--box__header--info search-txt">
                    <ng-template [ngIf]="isB2CAdminRole()">
                        <input class="form-control" placeholder="{{ 'Search' | translate }}"
                               [(ngModel)]="searchInfo.keyword">
                        <i *ngIf="searchInfo.keyword" class="fal fa-times" (click)="clearSearch()"></i>
                    </ng-template>
                </div>
                <div class="text-xs-right">
                    <span class="card--b2c--box__header__action">
                        <button *ngIf="isHome; else addNew"
                                type="button" class="btn btn-block pl-3"
                                [routerLink]="['/b2c-patients/coupons']">
                            {{ 'View All' | translate }}
                            <i class="fal fa-light fa-arrow-right"></i>
                        </button>
                        <ng-template #addNew>
                            <button type="button" class="btn btn-block pl-3"
                                    (click)="openFormModal({ action: 'create', title: 'Add Coupon', url: url })">
                                <i class="fal fa-light fa-plus"></i>
                                {{ 'Add new coupon' | translate }}
                            </button>
                        </ng-template>
                    </span>
                </div>
            </div>
        </div>

        <b2c-admin-filters-search *ngIf="!isHome"
                                  [hasClinic]="false"
                                  [hasDate]="true"
                                  [hasTestData]="false"
                                  (setFilterParams)="setFilterParams($event)"
                                  (searchData)="getItems()"></b2c-admin-filters-search>

        <div class="b2c-table--grid coupons" *ngIf="items.length">
            <div class="b2c-table--grid__body coupons__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-11 col-lg-10 coupons__column">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}"
                                 (click)="sortCoupons(column[0]);"
                                 title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && (sortedColumn === column[0]
                                                || (sortedColumn === 'expiration_date_sort' && column[0] === 'expiration_date')),
                                                'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let coupon of items
                        | orderBy : orderField: sortedColumn
                        | filterText: searchInfo.keyword:'code,description'
                        | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)"
                     class="row" [class.inactive]="!coupon.active">
                    <div class="col-xs-11 col-lg-10">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                <span *ngIf="column[0] !== 'active'"
                                      [class.expired]="column[0] === 'expiration_date' && isExpired(coupon['expiration_date'])"
                                      class="col col--{{column[0]}}">
                                    <i *ngIf="column[0] === 'code'" class="fal fa-copy"
                                       (click)="clipboard(coupon[column[0]], pop)"
                                       tooltip="{{'Copied : ' | translate}} {{ coupon[column[0]] }}" container="body" placement="top" triggers="click" #pop="bs-tooltip">
                                    </i>
                                    <span [ngSwitch]="column[0]">
                                        <span *ngSwitchCase="'article_type_id'"> {{ getArticleType(coupon[column[0]]) }} </span>
                                        <span *ngSwitchCase="'expiration_date'">
                                            <span *ngIf="!coupon[column[0]]; else colData">
                                                ∞
                                            </span>
                                            <ng-template #colData>
                                                {{ coupon[column[0]] }}
                                            </ng-template>
                                        </span>
                                        <span *ngSwitchCase="'usages'">
                                            {{ coupon[column[0]] }} / {{ coupon['max_number_of_usages'] || '∞' }}
                                        </span>
                                        <span *ngSwitchDefault> {{ coupon[column[0]] }} </span>
                                    </span>
                                </span>

                                <div class="" *ngIf="column[0] === 'active'">
                                    <mat-slide-toggle [(ngModel)]="coupon['active']" (change)="activate(coupon)"
                                                      [class.disabled]="params['action'] === 'read'">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-1 col-lg-2 table--grid__actions table--grid__actions--hover"
                         *ngIf="isB2CAdminRole()">
                        <div class="btn-group dropdown" dropdown>
                            <button class="btn btn-link table--grid__actions__ellipsis dropdown-toggle" dropdownToggle>
                                <i class="fas fa-ellipsis-h table--grid__actions__ellipsis__icon"
                                   aria-hidden="true"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right table--grid__actions__links">
                                <li class="dropdown-item"
                                    (click)="openFormModal({ action: 'update', id: coupon['id'], title: 'Edit Coupon ' + coupon['code'], url: '/home' });">
                                    <a class="btn btn-link table--grid__action-btn">
                                        <i class="fas fa-pencil-alt table--grid__actions__links__icon"
                                           aria-hidden="true"
                                           attr.name="{{ 'Edit' | translate }}"
                                           title="{{ 'Edit' | translate }}"></i>
                                    </a>
                                </li>
                                <li class="dropdown-item"
                                    (click)="openConfirmModal({
                                                    url: couponsService.url,
                                                    action: 'delete',
                                                    id: coupon['id'],
                                                    activated: coupon['active'],
                                                    title: 'Delete Coupon',
                                                    content: 'Are you sure you want to delete this Coupon?',
                                                    description: coupon['code'],
                                                    icon: 'far fa-trash-alt'
                                                })">
                                    <a class="btn btn-link table--grid__action-btn">
                                        <i class="far fa-trash-alt table--grid__actions__links__icon"
                                           attr.name="{{ 'Delete' | translate }}" aria-hidden="true"
                                           title="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                    </a>
                                </li>
                                <li class="dropdown-item" *ngIf="isActivatable"
                                    (click)="openConfirmModal({
                                                    url: 'coupons',
                                                    action: 'activate',
                                                    id: coupon['id'],
                                                    activated: coupon['active'],
                                                    title: coupon['activated'] ? 'Deactivate Coupon' : 'Activate Coupon',
                                                    content: coupon['active'] ? 'Are you sure you want to deactivate this coupon?' : 'Are you sure you want to activate this coupon?',
                                                    description: coupon['email'],
                                                    icon: (coupon.active)?'fas fa-ban':'far fa-check-circle'
                                                })">
                                    <a class="btn btn-link table--grid__action-btn"
                                       [ngClass]="{'table--grid__action-btn--lighter': !coupon.active}">
                                        <i class="table--grid__actions__links__icon"
                                           [ngClass]="(coupon.active)?'fas fa-ban':'far fa-check-circle'"
                                           aria-hidden="true"
                                           attr.name="{{ coupon.activated ?  ('Deactivate' | translate) : ('Activate' | translate) }}"
                                           title="{{ coupon.activated ?  ('Deactivate' | translate) : ('Activate' | translate) }}"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden && !isHome" [(page)]="currentPage"
                          [total]="(items | filterText: searchInfo.keyword:'code,description').length" [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
                          #pagination></pagination-component>
    <!-- Modal -->
    <div bsModal #modal="bs-modal" class="modal fade"
         [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''"
         tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-coupon">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ params['title'] | translate }}</h4>
                </div>
                <div class="modal-body">
                    <button type="button" class="btn btn-link close" (click)="hideModal()" aria-label="Close">
                    </button>
                    <div *ngIf="params['action'] === 'read' && isB2CAdminRole()">
                        <ul class="list-inline">
                            <li class="list-inline-item" *ngIf="isUpdatable">
                                <button class="btn btn-link"
                                        (click)="openFormModal({ action: 'update', id: params['id'], title: 'Edit User', url: couponsService.url });">
                                    <i class="fas fa-pencil-alt text-primary" aria-hidden="true"></i>
                                    <span>{{ 'Edit' | translate }}</span>
                                </button>
                            </li>
                            <li class="list-inline-item" *ngIf="isDeletable">
                                <button class="btn btn-link"
                                        (click)="openConfirmModal({
                                            url: couponsService.url,
                                            action: 'delete',
                                            id: params['id'],
                                            title: 'Delete Coupon',
                                            content: 'Are you sure you want to delete this Coupon?',
                                            description: params['description'],
                                            icon: 'far fa-trash-alt'
                                        });">
                                    <i class="far fa-trash-alt text-primary" aria-hidden="true"></i>
                                    <span>{{ 'Delete' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                        <hr/>
                    </div>
                    <ng-template [ngIf]="!formLoading">
                        <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)"
                              class="mat-form mat-form-coupon"  #formDirective="ngForm">
                            <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                                <div class="col-md-10">
                                    <div class="alert alert-danger">
                                        <div *ngFor="let error of errorMessage">
                                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                            {{ error | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <mat-form-field class="ps-content">
                                        <mat-select [placeholder]="'Article type' | translate" required="required"
                                                    formControlName="article_type_id">
                                            <mat-option *ngFor="let type of articleTypes"
                                                        [value]="type['id']">
                                                {{ type['type'] | translate }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-6" *ngIf="params['action'] === 'create'">
                                    <mat-form-field class="ps-content">
                                        <input type="email" matInput [placeholder]="'Number of coupons' | translate"
                                               required="required" formControlName="total_coupon"/>
                                        <small class="form-text text-danger"
                                               [hidden]="form.controls.total_coupon.valid || ((form.controls.total_coupon.pristine && !formSubmitted) || form.controls.total_coupon.disabled)">
                                            {{ 'Number only' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-xs-6" >
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="'% discount' | translate"
                                               required="required"
                                               formControlName="percent_discount"/>
                                        <small class="form-text text-danger"
                                               [hidden]="form.controls.percent_discount.valid || (form.controls.percent_discount.pristine && !formSubmitted)">
                                            {{ 'Number only and less than 100' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-xs-6" *ngIf="params['action'] !== 'create'">
                                    <div class="label">{{ 'Active' | translate }}</div>
                                    <div class="pt-1">
                                        <mat-slide-toggle formControlName="active"
                                                          [class.disabled]="params['action'] === 'read'">
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-6">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="'Max number of usages' | translate"
                                               formControlName="max_number_of_usages"/>
                                        <small class="form-text text-danger"
                                               [hidden]="form.controls.max_number_of_usages.valid || (form.controls.max_number_of_usages.pristine && !formSubmitted)">
                                            {{ 'Number only' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                                <div class="form-group col-xs-6">
                                    <div class="form-customized mat-form-field-wrapper {{ validateCssDueDate }}">
                                        <label>{{ 'Expiration date' | translate }}</label>
                                        <my-date-picker formControlName="expiration_date"
                                                        class="kl-datepicker"
                                                        placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions"
                                                        (inputFocusBlur)="onDueDateFocusBlur($event)"
                                                        (inputFieldChanged)="onDueDateInputChanged($event)">
                                        </my-date-picker>
                                        <div class="mat-input-underline mat-form-field-underline">
                                            <span class="mat-input-ripple mat-form-field-ripple"></span>
                                        </div>
                                        <small class="form-text" [hidden]="form.controls.expiration_date.valid
                                            || (form.controls.expiration_date.pristine && !formSubmitted)
                                            || form.controls.expiration_date.disabled">
                                            {{ 'Date format is dd.mm.yyyy' | translate }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <mat-form-field class="ps-content">
                                        <span>{{ 'Description *' | translate }}</span>
                                        <textarea id="coupon-desc" maxlength="600"
                                                  matInput required="required"
                                                  class="w-100 context-textarea" formControlName="description"></textarea>
                                        <small class="form-text text-danger" [hidden]="form.controls['description'].valid
                                                                            || (form.controls['description'].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button *ngIf="params['action'] !== 'read'"
                                            type="submit"
                                            class="btn btn-primary save">
                                        {{ 'Submit' | translate }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

</div>
<dialog-component #dialog></dialog-component>
